import React from "react";

import { OuterWrapper, Wrapper } from "./StyledComponents";

export interface CtasWrapperProps {
    children?: React.ReactNode;
    className?: string;
    isSticky?: boolean;
}

const CtasWrapperRT: React.FC<CtasWrapperProps> = (props) => {
    return (
        <OuterWrapper $isSticky={props.isSticky}>
            <Wrapper className={props.className}>{props.children}</Wrapper>
        </OuterWrapper>
    );
};

export default CtasWrapperRT;
